// Generated by CoffeeScript 1.11.1
(function() {
  module.exports = {
    parseRaw: function() {
      var i, j, ref, ref1;
      for (i = j = ref = this.chanPos, ref1 = this.chanPos + this.chan.length - 2; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
        this.channelData[i] = this.file.readByte();
      }
      return this.chanPos += this.chan.length - 2;
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/image_formats/layer_raw.js
// module id = 42
// module chunks = 0